
<template>
    <div class="card">
        <DataTable :value="roles" showGridlines dataKey="id" removableSort>
            <Column sortable field="name" header="Name" style="min-width: 12rem">
                <template #body="{ data }">
                    {{ prettyName(data.name) }}
                </template>
            </Column>
            <Column header="Users" field="users" :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
                <template #body="{ data }">
                    <div class="flex gap-1" v-if="selectedActionUserId != data.id">
                        <i class="pi pi-pencil cursor-pointer" @click="editUsers(data)" data-cy="edit-roles"></i>
                        <Tag v-for="user in data.users" :value="user.email" />
                    </div>
                    <div v-else>
                        <InputGroup v-if="!updatingUser">
                            <MultiSelect v-model="usersToEdit" display="chip" :options="sortedUsers" optionValue="id" optionLabel="email" placeholder="Select Users"
                            :maxSelectedLabels="3" class="w-full md:w-80" />
                            <Button icon="pi pi-check" severity="success" @click="updateUsers"/>
                            <Button icon="pi pi-times" severity="danger" @click="selectedActionUserId = null" />
                        </InputGroup>
                        <LoadingState v-else small ></LoadingState>
                    </div>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';

import {LOGIN_API_TYPE} from "@/src/model/apiTypes";

import { useStore } from 'vuex';
const store = useStore();


const selectedActionUserId = ref(null)

const roles = computed(() => store.getters['userStore/roles'])

const users = computed(() => store.getters['userStore/users'])

const usersToEdit  = ref([])
const sortedUsers = ref([])

const editUsers = (data) => {
    selectedActionUserId.value = data.id
    usersToEdit.value = data.users.map(user => user.id)
    sortedUsers.value = [...users.value].sort((a, b) => {
        // First selected users, then sort alphabetically
        if (usersToEdit.value.includes(a.id) && !usersToEdit.value.includes(b.id)) {
            return -1;
        } 
        if (!usersToEdit.value.includes(a.id) && usersToEdit.value.includes(b.id)) {
            return 1;
        } 
        return a.email.localeCompare(b.email);
    })
}


const updateUsers = async () => {
    await store.dispatch('userStore/updateRoleUsers', {
        roleId: selectedActionUserId.value,
        users: usersToEdit.value
    })
    selectedActionUserId.value = null
}

const prettyName = (name) => {
    return name.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
}
</script>
